import React from 'react';
import { Form, Input, Button, Modal, Space, Row, Col, Card } from 'antd';

interface ModalProps {
  open: boolean;
  onCreate: (values: any) => void;
  onCancel: () => void;
  title: string;
}

const CustomerGroupForm: React.FC<ModalProps> = ({ open, onCreate, onCancel, title }) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onCreate(values);
      })
      .catch((info) => {
        console.log('Validate failed:', info);
      });
  };

  return (
    <Modal
      open={open}
      onOk={() => {
        const values = form.getFieldsValue();
        onCreate(values);
      }}
      onCancel={onCancel}
      //width={200}
      style={{ top: 20 }}
      closable={false}
      footer={[
        <Space>
          <Button onClick={handleSubmit} type="primary">
            Lưu
          </Button>
          <Button onClick={onCancel}> Bỏ qua</Button>
        </Space>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        name="form-customer-group"
        size="small"
        autoComplete="off" 
      >
        <h3 className="mb-4 font-bold-weight">{title}</h3>
        <Card>
          <Row gutter={12}>
            <Col span={7}>Tên nhóm</Col>
            <Col span={17}>
              <Form.Item
                name="name"
                rules={[{ required: true, message: 'Please input name!' }]}
              >
                <Input placeholder="Tên nhóm khách hàng" />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>
    </Modal>
  );
};

export default CustomerGroupForm;
